
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuthReadiness } from '@/hooks/useAuthReadiness';

const fetchUserOrders = async (userId: string) => {
  const { data, error } = await supabase
    .from('orders')
    .select(`
      id,
      order_number,
      total_amount,
      status,
      created_at,
      payment_status,
      payment_method,
      order_items (
        id,
        quantity,
        price,
        products (
          name,
          image_url
        )
      )
    `)
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching user orders:', error);
    throw error;
  }
  
  return data;
};

export const useUserOrders = () => {
  const { user, canQueryUserData } = useAuthReadiness();
  const userId = user?.id;

  const { data: orders, isLoading, error } = useQuery({
    queryKey: ['user-orders', userId],
    queryFn: () => fetchUserOrders(userId!),
    enabled: canQueryUserData,
  });

  return {
    orders: orders ?? [],
    isLoading,
    error,
  };
};
